import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#FFD700] text-[#2C5F2D] py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              Contact Us
            </h3>
            <div className="space-y-2 text-sm">
              <p className="flex items-center gap-2">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
                <span>sales@malficoffee.com</span>
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              Quick Links
            </h3>
            <div className="space-y-2 text-sm">
              <Link to="/" className="block hover:text-white transition-colors cursor-pointer">
                Home
              </Link>
              <Link to="/gallery" className="block hover:text-white transition-colors cursor-pointer">
                Gallery
              </Link>
              <Link to="/event-gallery" className="block hover:text-white transition-colors cursor-pointer">
                Event Gallery
              </Link>
              <Link to="/contact" className="block hover:text-white transition-colors cursor-pointer">
                Contact
              </Link>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              Follow Us
            </h3>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/lemonadecoffeestore/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-[#2C5F2D] text-[#FFD700] rounded-full hover:bg-[#1a3a1b] transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-[#2C5F2D]/20 pt-6 text-center text-sm">
          <p>&copy; 2026 Lemonade Coffee Store. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></p>
        </div>
      </div>
    </footer>
  );
}